import React, { PureComponent } from 'react'
import Benefit from './Benefit'
import styles from './styles'
import grid from './original-ideas-icon.png'
import light from './put-map-icon.png'
import people from './share-icon.png'
import world from './make-difference-icon.png'

export default class Benefits extends PureComponent {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <Benefit title='Benefit 1:' src={grid}>
            Share resources with top industry professionals and gain access to
            strategic networking opportunities that can only strengthen your business
            or organization.
          </Benefit>
          <Benefit title='Benefit 2:' src={people}>
            Your business will have the opportunity to truly make a difference
            in the lives of those with neurological conditions.
          </Benefit>
          <Benefit title='Benefit 3:' src={world}>
            Put your business or organization on the map as community-driven and
            relevant to our city’s advancement, both crucial elements to a successful business.
          </Benefit>
          <Benefit title='Benefit 4:' src={light}>
            Be a leader in creating and executing advanced and original ideas
            within the field of neuroscience and its complementing industries.
          </Benefit>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Benefits/Benefits.js
 **/